// src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title,
  description,
  keywords,
  path = '',
  image = '/RemaH.png',
  type = 'website',
  // Pages réellement responsive : passer `responsive` pour rendre en largeur
  // d'écran réelle. Par défaut on conserve le viewport 1024 historique
  // (« affichage desktop forcé ») pour les pages non encore adaptées au mobile.
  responsive = false,
}) => {
  const siteUrl = 'https://remadia.com';
  const fullUrl = `${siteUrl}${path}`;
  const fullTitle = title ? `${title} | Remadia` : 'Remadia — Comprendre sa santé, simplement';
  const defaultDescription =
    "Remadia vous aide à comprendre votre santé grâce à une IA bienveillante : chat médical, analyse de prise de sang, recherche médicaments, articles par âge et numéros d'urgence.";
  const metaDescription = description || defaultDescription;
  const defaultKeywords =
    'santé, IA médicale, analyse prise de sang, médicaments, urgences, articles santé, enfants, adolescents, RGPD, chiffrement';
  const metaKeywords = keywords || defaultKeywords;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Viewport : device-width pour les pages responsive, sinon desktop forcé (1024) */}
      <meta
        name="viewport"
        content={
          responsive
            ? 'width=device-width, initial-scale=1'
            : 'width=1024, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes'
        }
      />

      {/* Base */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Remadia" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Autres */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="fr" />
      <meta name="author" content="Remadia" />
      <meta name="theme-color" content="#0F172A" />
    </Helmet>
  );
};

export default SEO;